import React from 'react'

export const DocsImage = ({ src, alt }) => {
  return (
    <>
      <img src={src} alt={alt} className="img-fluid" />
      <small>
        <i>{alt}</i>
      </small>
    </>
  )
}
